import { FilePicker } from './file-picker'
import type { Overlay } from '../view-api'
import { SlashMenu } from './slash-menu'
import { LinkMention } from './link-mention'
import { BlockSelection } from './block-selection'
import { BlockActions } from './block-actions'
import { TableControls } from './table-controls'
import { FloatingToolbar } from './floating-toolbar'
import { Placeholder, VisualViewport } from './viewport-placeholder'

// Typeahead Escape handlers precede the block-selection Escape handler.
export const overlays: Overlay[] = [SlashMenu, LinkMention, BlockSelection, BlockActions, TableControls, FloatingToolbar, Placeholder, VisualViewport, FilePicker]
export type { OverlayApi } from './shared'
